// @flow
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { SvgDefs } from './components/icon'
import Header from './components/header'
import Container from './components/container'
import Footer from './components/footer'
import './globals.module.css'
import './base.module.css'
import styles from './layout.module.css'

type Props = {
  isHeaderFloating: boolean,
  hasContainer: boolean,
  children: React$Node,
}

function Layout({ isHeaderFloating, hasContainer, children }: Props) {
  const data = useStaticQuery(graphql`
    query Layout {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const { title } = data.site.siteMetadata
  return (
    <div className={styles.root}>
      <Helmet titleTemplate={`%s | ${title}`} defaultTitle={title}>
        <html lang="en" />
        <meta charSet="utf-8" />
      </Helmet>
      <SvgDefs />
      <Header isFloating={isHeaderFloating} />
      <main className={styles.main}>
        {hasContainer ? <Container isMain>{children}</Container> : children}
      </main>
      <Footer />
      <div id="popper" />
    </div>
  )
}

Layout.defaultProps = {
  isHeaderFloating: false,
  hasContainer: true,
}

export default Layout
